export default function PoliceGeneralDetails () {
    return (
    <div>

<div className="police-bg bg-image">
            <div className="gap-spacer"></div>
            <div className="page-title mobile-center-title top-cap-outlines">
                <h1>Morrisville Borough Police</h1>
            </div>
            {/*Start Main Content*/}
            <div className="police-center-container mid-side-outlines">
                
                
                
                 {/*Start Police Sub-Menu*/}
                 <div className="police-sub-menu">
                    <div className="logo"></div>
                    <input className="menu-btn" type="checkbox" id="menu-btn"/>
                    <label className="menu-icon" for="menu-btn"><i className="fa-solid fa-bars"></i>&nbsp;Police Sub-Menu</label>
                    <ul className="menu">
                        <li><a href="/police">General</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776">CrimeWatch&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/documents">Documents</a></li>
                        <li><a href="/police/jobs">Jobs</a></li>
                        <li><a href="/police/personnel">Personnel</a></li>
                        <li><a href="/police/resources">Resources</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776/submit-tip">Submit-A-Tip&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/statistics">Statistics</a></li>
                    </ul>
                </div>
                {/*End Police Sub-Menu*/}

            
            {/*Start Section Below Sub-Menu*/}


            <div className="police-center-container">
                <div className="police-960-col-100p">


                    <div className="pd-top-non-mobile">
                        <div className="pd-top-row">

                            <div className="pd-top-row-left-side">

                                <div className="pd-emergency-number">
                                    <div className="police-general-phone-numbers">IN CASE OF EMERGENCY</div>
                                    <div className="police-general-phone-numbers">CALL 9-1-1</div>
                                </div>

                                <div className="pd-non-emergency-number">

                                    <div className="police-general-phone-numbers">Non-Emergency Dispatch</div>
                                    <div className="police-general-phone-numbers">Call 215-295-8111</div>
                                </div>


                            </div>

                            <div className="pd-top-row-right-side">
                                <img src="../img/mb-police-logo-main.png" alt="Morrisville Police Logo"/>
                            </div>

                        </div>
                    </div>


                    <div className="pd-top-mobile">
                        <div className="pd-mobile-logo">
                            <img src="../img/mb-police-logo-main.png" alt="Morrisville Police Logo"/>
                        </div>
                        <div className="pd-mobile-911">
                            IN CASE OF EMERGENCY</div>
                        <div className="pd-mobile-911">CALL 9-1-1</div>

                        <div className="pd-mobile-non-emergency">
                            Non-Emergency Dispatch</div>
                        <div className="pd-mobile-non-emergency"> Call 215-295-8111
                        </div>



                    </div>



                    <h4>Morrisville Police Station</h4>
<ul className="no-bullets">
    <li>
                            <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                                <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street<br/>Morrisville, PA 19067</a>
        </li>
                        <li>
                            <a href="tel:2152958112"><i className="fa-solid fa-phone"></i>&nbsp;Phone: 215-295-8112</a>
                        </li>
                        <li>
                            <a href="tel:2152958451"><i className="fa-solid fa-fax"></i>&nbsp;Fax: 215-295-8451</a>
                        </li>
                        Station Open 24 hours<br/>
                        Office Hours: Monday-Friday<br/> 8 a.m. - 4:30 p.m.
                    </ul>

                    <p>
                    <div className="pd-center-title">Mission Statement</div>
</p>

                    The mission of the Morrisville Borough Police Department is to improve the quality of life by preserving peace and safety for our community through the formulation of partnerships and creating positive interactions between the public and the police while continuing to serve the unique needs of Morrisville Borough.
                    <p>&nbsp;</p>
                    <div className="pd-center-title">Values Statement</div>
                    The Morrisville Borough Police Department comprises dedicated professionals committed to team concepts and creatively solving problems. We believe in:<br/>
                    <ul>
                        <li>The sanctity of human life and serving the community.</li>
                        <li>Courtesy and respect for all citizens.</li>
                        <li>The courage to do what is right.</li>
                        <li>Striving for continuous improvement.</li>
                    </ul>
                </div>



                {/*Start Section Below Sub-Menu*/}

            </div>
</div>
            <div className="page-footer bottom-cap-outlines">&nbsp;</div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>

            </div>
            
            


</div>
    )
}